import {FC, useContext, useState} from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import {useSetRecoilState} from 'recoil';

import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';
import {Box, Button, Divider, Modal, Stack, Toolbar, Typography} from '@mui/material';
import {EventBusContext} from '../../../providers/EventBus';
import {ServiceRequestService} from '../../../api/services/serviceRequest.service';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import {serviceRequestsQueryTrigger} from '../../../store/service-requests/atoms';
import ControlledInput from '../../../ui/controlled-input/ControlledInput';
import Status from '../../../ui/status/Status';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  width: 500,
  p: 2,
};

interface IServiceRequestSetStatus {
  open: boolean;
  handleClose: () => void;
  id: number;
}

export const ServiceRequestSetStatus: FC<IServiceRequestSetStatus> = ({open, handleClose, id}) => {
  const {control, handleSubmit} = useForm<{comment: string}>({
    defaultValues: {comment: ''},
  });
  const [loading, setLoading] = useState(false);
  const triggerQuery = useSetRecoilState(serviceRequestsQueryTrigger);
  const {bus} = useContext(EventBusContext);

  const handleSetStatus: SubmitHandler<{comment: string}> = async (data) => {
    setLoading(true);

    try {
      await ServiceRequestService.setStatus(id, 'EXECUTED', data.comment.trim());

      triggerQuery((v) => v + 1);
      handleClose();
    } catch (err: any) {
      bus?.emit('error', [err]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open}>
      <Box sx={style}>
        <Toolbar
          sx={{
            pl: {sm: 1},
            pr: {xs: 1, sm: 1},
          }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="h6" id="formTitle" component="div">
              Смена статуса:
            </Typography>
            <Status entity="serviceRequest" code="DONE" />
            <ArrowRightAltIcon />
            <Status entity="serviceRequest" code="EXECUTED" />
          </Stack>
        </Toolbar>
        <Divider sx={{m: '10px 0'}} />
        <Stack direction="column" spacing={3} sx={{mt: 2}}>
          <Stack direction="column" spacing={1.5}>
            <Typography variant="body2">Причина смены статуса</Typography>
            <ControlledInput
              control={control}
              name="comment"
              rules={{
                required: 'Обязательно для заполнения',
              }}
              size="small"
            />
          </Stack>
          <Stack direction="row" sx={{justifyContent: 'space-between'}}>
            <Button variant="outlined" color="error" disabled={loading} onClick={handleClose}>
              Отменить
            </Button>
            <LoadingButton
              color="primary"
              variant="contained"
              onClick={handleSubmit(handleSetStatus)}
              loading={loading}
            >
              Подтвердить
            </LoadingButton>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};
